import { Routes, Route } from 'react-router-dom';
import { Layout } from '../../components/MentorDashboard/Layout';
import { Dashboard } from '../../components/MentorDashboard/Dashboard';
import { AssignTeam } from '../../components/MentorDashboard/AssignTeam';
import { TeamDetails } from '../../components/MentorDashboard/TeamDetails';
import { IdeaFeedback } from '../../components/MentorDashboard/IdeaFeedback';
import TeamConnect from '../../components/MentorDashboard/TeamConnect';

export default function MentorDashboardPage() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="assign-team" element={<AssignTeam />} />
        <Route path="team-details/:teamId" element={<TeamDetails />} />
        <Route path="idea-feedback" element={<IdeaFeedback />} />
        <Route path="team-connect" element={<TeamConnect />} />
      </Route>
    </Routes>
  );
}
